import axios from 'axios';

/**
 * API base URL
 *
 * Local development:
 * - npm start uses http://localhost:5000/api
 *
 * Live production:
 * - npm run build uses /api
 * - Browser calls https://zypio.lk/api
 * - This avoids Mixed Content error
 */


const API_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? '/api'
    : 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Attach token if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;